import { Navigate, useLocation } from "react-router-dom";
import { useMemo } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const redirectState = useMemo(() => ({ from: location.pathname }), [location.pathname]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#030303]" data-testid="protected-loading">
        <Loader2 className="w-6 h-6 text-[#00FFA3] animate-spin" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={redirectState} replace />;
  }
  return children;
}
